export default function(path, width, height) {

    this._images.push({path:path, width: width, height:height})

    return this;
};
